import React from 'react'
import Helmet from 'react-helmet'

const Akce = () => (
  <article>
    <Helmet title="Muvko - Akce" />
    <h1>Akce</h1>

    <p>Zábavu si užíváme nejenom na trénincích, ale také mimo tělocvičnu. Společně jezdíme a zúročujeme dřinu na Spartan Race, nebo třeba Red Bull 400.</p>

    <p>Tou nejoblíbenější akcí je Muvko Camp, kde si pořádně zamakáš, vypotíš krev, ale taky zasměješ, nadýcháš se čerstvého vzduchu a načerpáš spoustu pozitivní energie.</p>

    <p>Kromě sportovních výkonů spolu podnikáme i jiné aktivity, jako jsou konzerty, rafty, výlety a vše, co Tě jenom napadne.</p>
  </article>
);

export default Akce



// WEBPACK FOOTER //
// ./src/pages/akce.js